import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { commonMessages } from "@temp/intl";
import { useAuth, useCart } from "@saleor/sdk";
import Media from "react-media";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import useLocalStorage from "@hooks/useLocalStorage"; // import { ContryList } from "@components/molecules/ContryList/ContryList";

import { MenuDropdown, Offline, Online, OverlayContext, OverlayTheme, OverlayType } from "..";
import * as appPaths from "../../app/routes";
import { maybe } from "../../core/utils";
import NavDropdown from "./NavDropdown";
import { TypedMainMenuQuery } from "./queries";
import cartImg from "../../images/cart.svg";
import hamburgerHoverImg from "../../images/hamburger-hover.svg";
import hamburgerImg from "../../images/hamburger.svg";
import logoImg from "../../images/lachiever-logo.svg";
import searchImg from "../../images/search.svg";
import userImg from "../../images/user.svg";
import countryImg from "../../images/contry/en.svg";
import { mediumScreen, smallScreen } from "../../globalStyles/scss/variables.scss";
import "./scss/index.scss";
import { localeNames, LocaleContext } from "../Locale";

var MainMenu = function MainMenu() {
  var _useAuth = useAuth(),
      user = _useAuth.user,
      signOut = _useAuth.signOut;

  var _useCart = useCart(),
      items = _useCart.items;

  var handleSignOut = function handleSignOut() {
    signOut();
  }; // when you select a contry as your display language dependency


  function doFilterContry() {
    var key = Object.keys(localeNames).filter(function (i) {
      if (localeNames[i] === currentLanguage) {
        return i;
      }
    });
    return key[0];
  }

  var context = useContext(LocaleContext);

  var _useLocalStorage = useLocalStorage("locale", context.localeLanguage),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      storageLocale = _useLocalStorage2[0],
      setStorageLocale = _useLocalStorage2[1];

  var _useState = useState(localeNames[context.localeLanguage || storageLocale]),
      _useState2 = _slicedToArray(_useState, 2),
      currentLanguage = _useState2[0],
      setCurrentLanguage = _useState2[1]; // async function onLanguageChange(value) {
  //   await setCurrentLanguage(value);
  //   location.reload();
  // }


  function onClickLanguageLi(_x) {
    return _onClickLanguageLi.apply(this, arguments);
  }

  function _onClickLanguageLi() {
    _onClickLanguageLi = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(value) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return setCurrentLanguage(value);

            case 2:
              location.reload();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _onClickLanguageLi.apply(this, arguments);
  }

  useEffect(function () {
    function localeChange() {
      return _localeChange.apply(this, arguments);
    }

    function _localeChange() {
      _localeChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var newFlag;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return setStorageLocale(doFilterContry());

              case 2:
                _context.next = 4;
                return import("../../images/contry/".concat(doFilterContry(), ".svg"));

              case 4:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 7;
                  break;
                }

                _context.t0 = "";

              case 7:
                newFlag = _context.t0;
                _context.next = 10;
                return setFlag(newFlag.default || "");

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _localeChange.apply(this, arguments);
    }

    localeChange();
  }, [currentLanguage]); // values for ContrySelectCmp

  var _useState3 = useState(countryImg),
      _useState4 = _slicedToArray(_useState3, 2),
      flag = _useState4[0],
      setFlag = _useState4[1];

  var laguages = Object.values(localeNames).map(function (i) {
    return i;
  }); // const arr = laguages.map(i => {
  //   const obj = { label: i, value: i };
  //   return obj;
  // });
  // const DEFAULT_PROPS = {
  //   sortOptions: arr,
  //   activeSortOption: currentLanguage,
  //   activeFiltersAttributes: [],
  //   onCloseFilterAttribute: () => {},
  // };

  var cartItemsQuantity = items && items.reduce(function (prevVal, currVal) {
    return prevVal + currVal.quantity;
  }, 0) || 0;
  return React.createElement(OverlayContext.Consumer, null, function (overlayContext) {
    return React.createElement("nav", {
      className: "main-menu",
      id: "header"
    }, React.createElement("div", {
      className: "main-menu__left"
    }, React.createElement(Link, {
      to: appPaths.baseUrl
    }, React.createElement(ReactSVG, {
      path: logoImg
    }))), React.createElement("div", {
      className: "main-menu__center"
    }, React.createElement(TypedMainMenuQuery, {
      renderOnError: true,
      displayLoader: false
    }, function (_ref) {
      var data = _ref.data;
      var items = maybe(function () {
        return data.shop.navigation.main.items;
      }, []); // console.log("mainMenuItem", items);

      items.forEach(function (x) {
        if (x.name === "Discover Us") {
          x.url = "/discover-us";
        }

        if (x.name === "Our Ingredients") {
          x.url = "/ingredients";
        }
      });
      return React.createElement("ul", null, React.createElement(Media, {
        query: {
          maxWidth: mediumScreen
        },
        render: function render() {
          return React.createElement("li", {
            "data-test": "toggleSideMenuLink",
            className: "main-menu__hamburger",
            onClick: function onClick() {
              return overlayContext.show(OverlayType.sideNav, OverlayTheme.left, {
                data: items
              });
            }
          }, React.createElement(ReactSVG, {
            path: hamburgerImg,
            className: "main-menu__hamburger--icon"
          }), React.createElement(ReactSVG, {
            path: hamburgerHoverImg,
            className: "main-menu__hamburger--hover"
          }));
        }
      }), React.createElement(Media, {
        query: {
          minWidth: mediumScreen
        },
        render: function render() {
          return items.map(function (item) {
            return React.createElement("li", {
              "data-test": "mainMenuItem",
              className: "main-menu__item",
              key: item.id
            }, React.createElement(NavDropdown, _extends({
              overlay: overlayContext
            }, item)));
          });
        }
      }), React.createElement(Online, null, React.createElement(Media, {
        query: {
          maxWidth: smallScreen
        },
        render: function render() {
          return React.createElement(React.Fragment, null, user ? React.createElement(MenuDropdown, {
            suffixClass: "__rightdown",
            head: React.createElement("li", {
              className: "main-menu__icon main-menu__user--active"
            }, React.createElement(ReactSVG, {
              path: userImg
            })),
            content: React.createElement("ul", {
              className: "main-menu__dropdown"
            }, React.createElement("li", {
              "data-test": "mobileMenuMyAccountLink"
            }, React.createElement(Link, {
              to: appPaths.accountUrl
            }, React.createElement(FormattedMessage, commonMessages.myAccount))), React.createElement("li", {
              "data-test": "mobileMenuOrderHistoryLink"
            }, React.createElement(Link, {
              to: appPaths.orderHistoryUrl
            }, React.createElement(FormattedMessage, commonMessages.orderHistory))), React.createElement("li", {
              "data-test": "mobileMenuAddressBookLink"
            }, React.createElement(Link, {
              to: appPaths.addressBookUrl
            }, React.createElement(FormattedMessage, commonMessages.addressBook))), React.createElement("li", {
              onClick: handleSignOut,
              "data-test": "mobileMenuLogoutLink"
            }, React.createElement(FormattedMessage, commonMessages.logOut)))
          }) : React.createElement("li", {
            "data-test": "mobileMenuLoginLink",
            className: "main-menu__icon",
            onClick: function onClick() {
              return overlayContext.show(OverlayType.login, OverlayTheme.left);
            }
          }, React.createElement(ReactSVG, {
            path: userImg
          })));
        }
      })));
    })), React.createElement("div", {
      className: "main-menu__right"
    }, React.createElement("ul", null, React.createElement(Online, null, React.createElement(Media, {
      query: {
        minWidth: smallScreen
      },
      render: function render() {
        return React.createElement(React.Fragment, null, user ? React.createElement(MenuDropdown, {
          head: React.createElement("li", {
            className: "main-menu__icon main-menu__user--active"
          }, React.createElement(ReactSVG, {
            path: userImg
          })),
          content: React.createElement("ul", {
            className: "main-menu__dropdown"
          }, React.createElement("li", {
            "data-test": "desktopMenuMyAccountLink"
          }, React.createElement(Link, {
            to: appPaths.accountUrl
          }, React.createElement(FormattedMessage, commonMessages.myAccount))), React.createElement("li", {
            "data-test": "desktopMenuOrderHistoryLink"
          }, React.createElement(Link, {
            to: appPaths.orderHistoryUrl
          }, React.createElement(FormattedMessage, commonMessages.orderHistory))), React.createElement("li", {
            "data-test": "desktopMenuAddressBookLink"
          }, React.createElement(Link, {
            to: appPaths.addressBookUrl
          }, React.createElement(FormattedMessage, commonMessages.addressBook))), React.createElement("li", {
            onClick: handleSignOut,
            "data-test": "desktopMenuLogoutLink"
          }, React.createElement(FormattedMessage, commonMessages.logOut)))
        }) : React.createElement("li", {
          "data-test": "desktopMenuLoginOverlayLink",
          className: "main-menu__icon",
          onClick: function onClick() {
            return overlayContext.show(OverlayType.login, OverlayTheme.right);
          }
        }, React.createElement(ReactSVG, {
          path: userImg
        })));
      }
    }), React.createElement("li", {
      "data-test": "menuSearchOverlayLink",
      className: "main-menu__search",
      onClick: function onClick() {
        return overlayContext.show(OverlayType.search, OverlayTheme.right);
      }
    }, React.createElement(ReactSVG, {
      path: searchImg
    })), React.createElement("li", {
      "data-test": "menuCartOverlayLink",
      className: "main-menu__icon main-menu__cart",
      onClick: function onClick() {
        overlayContext.show(OverlayType.cart, OverlayTheme.right);
      }
    }, React.createElement(ReactSVG, {
      path: cartImg
    }), cartItemsQuantity > 0 ? React.createElement("span", {
      className: "main-menu__cart__quantity"
    }, cartItemsQuantity) : null), React.createElement("li", {
      "data-test": "menuCurrencyOverlayLink",
      className: "main-menu__country"
    }, React.createElement(Media, {
      query: {
        minWidth: smallScreen
      },
      render: function render() {
        return React.createElement(React.Fragment, null, React.createElement(MenuDropdown, {
          head: React.createElement(ReactSVG, {
            path: flag
          }),
          content: React.createElement("ul", {
            className: "language_select_menu_dropdown"
          }, laguages.map(function (i, idx) {
            return React.createElement("li", {
              key: idx,
              onClick: function onClick() {
                return onClickLanguageLi(i);
              }
            }, i);
          })),
          dropdownType: "flag_dropdown"
        }));
      }
    }))), React.createElement(Offline, null, React.createElement("li", {
      className: "main-menu__offline"
    }, React.createElement(Media, {
      query: {
        minWidth: mediumScreen
      },
      render: function render() {
        return React.createElement("span", null, React.createElement(FormattedMessage, {
          id: "components.MainMenu.MainMenu.4144939532",
          defaultMessage: "Offline"
        }));
      }
    }))))));
  });
};

export default MainMenu;